module.exports = __webpack_public_path__ + "static/product-cab5ade07aef4573d80a653bcd11add1.mp4";